import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UnSavedChangesRouteGuard } from 'src/app/shared/routeguards/unsavedChangesRouteGuard';
import { PermissionsEditComponent } from './permissions-edit/permissions-edit.component';
import { PermissionsGridComponent } from './permissions-grid/permissions-grid.component';


const routes: Routes = [
  { path: '', component: PermissionsGridComponent },
  { path: "permission-edit", component: PermissionsEditComponent, canDeactivate: [UnSavedChangesRouteGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PermissionRoutingModule { }
